<script setup lang="ts">
import { keys } from "~/utilities/injection"

const showVideo = ref(false)
const article = inject(keys.currentArticle)
</script>

<template>
  <section v-if="article?.video">
    <UButton
      variant="quite"
      theme="medium"
      :class="{ 'mb-10': !showVideo }"
      :data-pendo="`video-suggested-solution'-${showVideo ? 'close' : 'open'}`"
      @click="showVideo = !showVideo"
    >
      <template #prepend>
        <UIcon
          :name="`${showVideo ? 'close' : 'play-filled'}`"
          size="xxs"
          class="rounded-full bg-[--theme-medium] p-3 text-white"
        />
      </template>

      <span
        class="flex items-center gap-4 pl-2 text-xl font-bold text-[--theme-dark]"
      >
        {{ showVideo ? "Lukk" : "Se" }} videoforklaring
      </span>
    </UButton>
    <UVideo
      v-if="showVideo"
      :video="article.video"
      :is-dark="false"
      auto-play
    />
  </section>
</template>
